import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { RemitServiceLine, RemitServiceLinePayload } from '@/types/billing';
import PaginatedResponse from '@/types/paginatedResponse';
import RepositoryResponse from '@/types/repositoryResponse';

import { createRepository } from './GenericRepository';

const basePath = '/api/billing/remit_service_lines';

export const remitServiceLineRepository = createRepository<
  RemitServiceLine,
  RemitServiceLinePayload
>(basePath);

const RemitServiceLineRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async list(
      params: Record<string, string> = {}
    ): Promise<RepositoryResponse<PaginatedResponse<RemitServiceLine[]>>> {
      return remitServiceLineRepository.list({ host, params });
    },

    async get({ id }: { id: string }): Promise<RepositoryResponse<RemitServiceLine>> {
      return remitServiceLineRepository.get({ host, id });
    },
    async create({ data }: { data: RemitServiceLinePayload }): Promise<RemitServiceLine> {
      return remitServiceLineRepository.create({ host, data });
    },
    async update({
      id,
      data
    }: {
      id: string;
      data: RemitServiceLinePayload;
    }): Promise<RemitServiceLine> {
      return remitServiceLineRepository.update({ host, id: id, data });
    },
    async delete({ id }: { id: string }) {
      return await remitServiceLineRepository.delete({ host, id });
    }
  };
};

export default RemitServiceLineRepository;
